import styled from "styled-components";
import { MDBIcon } from 'mdbreact';

export const Normaltd = styled.td`
  position: relative;
  border-radius: 0.3rem;
`

export const Styledli = styled.li`
  margin: 0 0.5rem;
`;

export const ContentsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    display: flex;
    align-content: space-between;
  }
  > textarea {
    border-radius: 0.3rem;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > h1 {
    text-align: left;
  }
`;

export const StyledIcon = styled(MDBIcon)`
  font-size: 0.8rem;
  padding: 0.2rem;
  margin: 0.2rem;
  height: 1.6rem;
  width: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #495057;
  background-color: #f1f1f1;
  border-radius: 50%;
  opacity: 0.5;

  :hover {
    cursor: pointer;
    color: #f1f1f1;
    background-color: #495057;
  }
`;

export const StyledInput = styled.input`
  height: 2.2rem;
  padding: 0.5rem;
  margin: 0.3rem;
  border-radius: 1rem;
`;
